import styled, { css } from "styled-components";
import { color, hoverColor, onHover, typeStyle, units } from "@m/alchemy-theme";
import { PopperBox } from "../popper/PopperBox";
import { Content } from "../popper/PopperBox.styled";
import { NakedButton } from "../naked-button/NakedButton";
import { CloseButton } from "../close-button/CloseButton";
const HIT_AREA_OFFSET = 0.5;
export const HelpIconButton = styled(NakedButton) `
  display: inline-flex;
  margin: -${units(HIT_AREA_OFFSET)} ${units(0.25)};
  padding: ${units(HIT_AREA_OFFSET)};

  svg {
    color: ${color("base", { palette: "structural" })};
  }

  ${onHover(css `
    svg {
      color: ${hoverColor("base", { palette: "expressiveInformative" })};
    }
  `)}
`;
export const CloseIconButton = styled(CloseButton) `
  position: absolute;
  z-index: 1;
  top: ${units(1)};
  right: ${units(1)};
`;
export const HelpContentBox = styled(PopperBox) `
  ${Content} {
    padding: ${units(1.5)} ${units(4)} ${units(1.5)} ${units(2)};
  }

  a {
    color: ${color("typeLink")};
    cursor: pointer;
    transition: color 200ms ease;

    ${typeStyle("link")};

    &:hover,
    &:focus {
      color: ${color("base", { palette: "interactiveConstructive" })};
    }
  }
`;
